import { ModalDirective } from 'ng2-bootstrap/components/modal';
import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  ViewChild
} from '@angular/core';
import { TranslateService } from '../../shared/translate';
import { CostAndExpenseModel } from '../../cost-expenses/models/cost-expense.model';
import { WeGoConfig, DataListModel } from '../../shared/config';
import { FlatPickrModel } from '../../plugins/flatpickr/flatpickr.model';
import { CostAndExpenseService } from '../../cost-expenses/models/cost-expense.service';
import { AuthService } from '../../shared/models/auth.service';
import { InvoiceService } from '../models/invoice.service';
import { BookingService } from '../../booking/models/booking.service';
import { DropdownModel } from '../../report/models/report-filter.model';

@Component({
  selector: 'wego-manual-invoice-line-popup',
  template: require('../views/manual-invoice-line.component.html'),
  providers: [CostAndExpenseService, InvoiceService, BookingService],
  styles: [
    `
    .form-horizontal .control-label{
      text-align: left;
    }
  `
  ]
})
export class ManualInvoiceLinePopupComponent implements OnInit, OnDestroy {
  errorModel: any[];
  apiErrorMsg: any;
  costTypeList: any;
  _model: CostAndExpenseModel = new CostAndExpenseModel();
  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  flatPickrConfigFrom: FlatPickrModel;
  BookingList: any[] = [];
  costAndExpenseList: CostAndExpenseModel[] = [];
  DataListModel: DataListModel = new DataListModel();
  vatSettingList: DropdownModel[];
  isNew: boolean = true;
  existingExpenseMsg: string;
  // NoDataValidation : string;
  vatSettingDefaultCost: boolean;
  _selectedExpenseHashIdList: string[];

  @ViewChild('receiptFile') public receiptFile: any;
  @ViewChild('manualInvoiceLineModal')
  public manualInvoiceLineModal: ModalDirective;
  @ViewChild('manualInvoiceLineUpdate') public manualInvoiceLineUpdate: any;
  @ViewChild('costAndExpensePopup') public costAndExpensePopup: any;

  @Input()
  set model(model: CostAndExpenseModel) {
    this._model = model;
  }
  get model(): CostAndExpenseModel {
    return this._model;
  }

  @Input()
  set SelectedExpenseHashIdList(selectedExpenseHashIdList: string[]) {
    this._selectedExpenseHashIdList = selectedExpenseHashIdList;
  }
  get SelectedExpenseHashIdList() {
    return this._selectedExpenseHashIdList;
  }

  // @Input()
  // set addreseeOrganizationId(addreseeOrganizationId: string) {
  //   this._addreseeOrganizationId = addreseeOrganizationId;
  // }
  // get addreseeOrganizationId() { return this._addreseeOrganizationId; }

  @Output() OnSuccessSelect = new EventEmitter();

  public costAndExpensesList: CostAndExpenseModel[] = [];

  constructor(
    private translate: TranslateService,
    private costAndExpenseService: CostAndExpenseService,
    private authService: AuthService,
    private invoiceService: InvoiceService,
    private bookingService: BookingService
  ) {}

  ngOnInit() {
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    //this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
  }

  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = true;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }

  public GetCostTypeList() {
    this.costAndExpenseService
      .GetDropdownCostTypeList(
        '',
        this.model.recipientDriverHashId,
        this.model.recipientOrganizationHashId
      )
      .subscribe(
        res => {
          this.costTypeList = res.data;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GetBookingList() {
    this.invoiceService
      .GetDropdownBookingList(
        this.model.sharedVehicleGroupDriverHashId,
        this.model.recipientOrganizationHashId
      )
      .subscribe(
        res => {
          this.BookingList = res.data;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GetApprovedCostAndExpenseList() {
    this.costAndExpenseService
      .GetApprovedExpenseList(
        this.model.sharedVehicleGroupDriverHashId,
        this.model.recipientOrganizationHashId
      )
      .subscribe(
        res => {
          this.costAndExpenseList = res.data;
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          // this.NoDataValidation = res.error;
          console.log(this.DataListModel);
          this.costAndExpenseList = this.costAndExpenseList.filter(
            x =>
              !(
                this.SelectedExpenseHashIdList.indexOf(x.costAndExpenseHashId) >
                -1
              )
          );
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public show() {
    this.apiErrorMsg = '';
    this.existingExpenseMsg = '';
    this.errorModel = [];
    this.manualInvoiceLineModal.show();
    this.GetBookingList();
    this.GetCostTypeList();
    this.GetVatSettingDropdownList();
    this.GetApprovedCostAndExpenseList();
  }

  public hide() {
    this.manualInvoiceLineModal.hide();
  }

  private Confirm($event: any) {
    this.hide();
  }

  private OnBookingChange() {
    this.GetVatSettingDropdownList();
  }

  public GetVatSettingDropdownList() {
    if (this.model.bookingHashId) {
      this.bookingService
        .GetVatSettingDropdownList(this.model.bookingHashId)
        .subscribe(
          res => {
            if (res.data) {
              this.vatSettingList = res.data;
              if (this.vatSettingList.length > 0) {
                this.model.reportedVatPercentage = this.vatSettingList[0].data;
              }
              //this.GetVatSettingDefaultValues();
            } else {
              this.apiErrorMsg = res.error;
            }
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          }
        );
    }
  }

  public GetVatSettingDefaultValues() {
    this.bookingService
      .GetVatSettingDefaultValues(this.model.bookingHashId)
      .subscribe(
        res => {
          if (res.data) {
            const vatSettingDefaultValues = res.data;
            this.vatSettingDefaultCost =
              vatSettingDefaultValues.vatSettingDefaultCost;
          } else {
            this.errorModel = res.error;
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public onSubmit() {
    if (this.isNew) {
      let frmData: FormData = new FormData();
      this.model.reportedByDriver = false;
      if (
        this.receiptFile &&
        this.receiptFile.nativeElement &&
        this.receiptFile.nativeElement.files &&
        this.receiptFile.nativeElement.files.length > 0
      ) {
        frmData.append(
          'receiptFile',
          this.receiptFile.nativeElement.files[0],
          this.receiptFile.nativeElement.files[0].name
        );
      }

      if (this.model) {
        frmData.append('manualInvoiceLine', JSON.stringify(this.model));
      }

      this.UploadManualLine(frmData);
    } else {
      let selectedExpense = this.costAndExpenseList
        .filter(x => x.isChecked)
        .map(x => x);
      if (!selectedExpense || selectedExpense.length == 0) {
        this.existingExpenseMsg = this.translate.instant(
          'LblSelectAtLeastOneExpense'
        );
      } else {
        this.existingExpenseMsg = '';
        this.OnSuccessSelect.emit({ CostAndExpenseModelList: selectedExpense });
        this.hide();
      }
    }
  }

  public ClearFileInput() {
    if (this.receiptFile && this.receiptFile.nativeElement) {
      this.receiptFile.nativeElement.value = '';
    }
  }

  public UploadManualLine(formData: FormData) {
    this.invoiceService
      .UpdateCostAndExpenses(formData, this._model.module)
      .subscribe(
        res => {
          console.log(res);
          if (res.data) {
            this.errorModel = [];
            this.ClearFileInput();

            if (!this._model.costAndExpenseHashId) {
              // this._model.approvedVatPercentage = this._model.reportedVatPercentage;
              // this._model.reportedVatAmount = (
              //   this._model.reportedAmountExVat *
              //   this._model.reportedVatPercentage /
              //   100
              // ).valueOf();
              // this._model.approvedAmountVat = this._model.reportedVatAmount;
              // this._model.reportedAmountInVat =
              //   Number.parseFloat(this._model.reportedAmountExVat.toString()) +
              //   Number.parseFloat(this._model.reportedVatAmount.toString());
              // this._model.approvedAmountInVat = this._model.reportedAmountInVat;
              // this._model.approvedAmountExVat = this._model.reportedAmountExVat;
              this._model.costAndExpenseHashId = res.data;
              this.costAndExpenseService
                .GetCostAndExpenseByHashId(this._model.costAndExpenseHashId)
                .subscribe(
                  res => {
                    this._model.approvedVatPercentage = res.data.reportedVatPercentage;
                    this._model.reportedVatAmount = (res.data.reportedAmountExVatActual * res.data.reportedVatPercentage / 100).valueOf();
                    this._model.approvedAmountVat = res.data.approvedAmountVat;
                    this._model.reportedAmountInVat = res.data.reportedAmountInVat;
                    this._model.approvedAmountInVat = res.data.approvedAmountInVat;
                    this._model.approvedAmountExVat = res.data.approvedAmountExVat;
                    this.OnSuccessSelect.emit({ CostAndExpenseModel: this._model });
                    this.hide();
                  },
                  error => {
                    this.apiErrorMsg = this.authService.HandleErrorStatusCode(
                      error
                    );
                  }
                );
            }
          } else {
            this.errorModel = res.error;
          }
        },
        error => {
          console.log(error);
          this.authService.HandleErrorStatusCode(error);
        }
      );
  }
  public ShowUpdateManualInvoiceLinePopup(expense: CostAndExpenseModel) {
    this.manualInvoiceLineUpdate.model = expense;

    if (!expense.reportedByDriver) {
      this.manualInvoiceLineUpdate.show(true);
    } else {
      expense.isEditable = false;
      this.costAndExpensePopup.show(expense);
    }
  }

  public ManualInvoiceLineUpdateSuccess($event: any) {
    console.log($event);
    let cost = $event.CostAndExpenseModel;
    let costExpenseIndex = this.costAndExpenseList.findIndex(
      x => x.costAndExpenseHashId == cost.costAndExpenseHashId
    );
    if (costExpenseIndex >= 0) {
      this.costAndExpenseList[costExpenseIndex] = cost;
    }
  }

  public ChildPopupHidden() {
    document.body.classList.add('modal-open');
  }

  public SetVatDefaultCost(vatSettingDefaultCost: boolean) {
    return vatSettingDefaultCost
      ? this.translate.instant('LblExcludingVat')
      : this.translate.instant('LblIncludingVat');
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/invoice/components/manual-invoice-line.component.ts